import { TRAINING_ACTION as ACTION_TYPE } from '../types/actionTypes';
const setTrainingStep = dispatch => step => dispatch({
  type: ACTION_TYPE.SET_TRAINING_STATUS,
  payload: {
    trainingStep: step
  }
});
const setTrainingError = dispatch => error => dispatch({
  type: ACTION_TYPE.SET_TRAINING_ERROR,
  payload: {
    trainingError: error
  }
});
const setTrainingComplete = dispatch => complete => dispatch({
  type: ACTION_TYPE.SET_TRAINING_COMPLETE,
  payload: {
    trainingComplete: complete
  }
});
const setShowTrainingScreen = dispatch => show => dispatch({
  type: ACTION_TYPE.SET_SHOW_TRAINING_SCREEN,
  payload: {
    showTrainingScreen: show
  }
});
const setUnsavedKeywords = dispatch => keywords => dispatch({
  type: ACTION_TYPE.SET_UNSAVED_KEYWORDS,
  payload: {
    unsavedKeywords: keywords
  }
});
const setGeneratedKeywords = dispatch => keywords => dispatch({
  type: ACTION_TYPE.SET_GENERATED_KEYWORDS,
  payload: {
    generatedKeywords: keywords
  }
});
const setSummaryCounts = dispatch => counts => dispatch({
  type: ACTION_TYPE.SET_SUMMARY_COUNTS,
  payload: {
    summaryCounts: counts
  }
});
const setShouldRefetchOnOpen = dispatch => val => dispatch({
  type: ACTION_TYPE.SET_SHOULD_REFETCH_ON_OPEN,
  payload: {
    shouldRefetchOnOpen: val
  }
});
const setShowTrainingErrorToast = dispatch => val => dispatch({
  type: ACTION_TYPE.SET_SHOW_TRAINING_ERROR_TOAST,
  payload: {
    showTrainingErrorToast: val
  }
});
// sometimes we need to update multiple state values at once
const setMultiple = dispatch => payload => dispatch({
  type: ACTION_TYPE.SET_MULTIPLE,
  payload
});
export default {
  setTrainingStep,
  setTrainingError,
  setTrainingComplete,
  setShowTrainingScreen,
  setUnsavedKeywords,
  setGeneratedKeywords,
  setSummaryCounts,
  setShouldRefetchOnOpen,
  setShowTrainingErrorToast,
  setMultiple
};